import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppMaterialModule } from 'src/app/app-material.module';
import { ContractNumberSearchModel } from 'src/app/models/ContractNumberSearchModel';
import { RequestService } from 'src/app/services/request/request.service';

@Component({
  selector: 'app-contract-request-search-modal',
  templateUrl: './contract-request-search-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    AppMaterialModule,
    MatOptionModule,
    NgIf,
    ReactiveFormsModule,
  ],
  styleUrls: ['../request-target-search.component.scss'],
})
export class ContractRequestSearchModalComponent implements OnInit {
  @Output()
  selectedOptionChange: EventEmitter<ContractNumberSearchModel | null> =
    new EventEmitter();

  typeAheadOptions: ContractNumberSearchModel[] = [];
  selectedOption: ContractNumberSearchModel | null = null;
  inputFormControl: FormControl = new FormControl('', [Validators.required]);

  constructor(private requestService: RequestService) {}

  ngOnInit(): void {
    this.inputFormControl.setValidators([
      Validators.required,
      this.contractNumberValidator.bind(this),
    ]);
    this.inputFormControl.setValue('');

    this.typeAheadOptions = [];
    this.selectedOption = null;

    this.inputFormControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        this.searchTypeAheadOptions(value);

        // Clear selected option when user types
        if (value != this.selectedOption?.contractNumber) {
          this.selectedOption = null;
        }

        if (this.selectedOption === null) {
          this.selectedOptionChange.emit(null);
        }
      });
  }

  searchTypeAheadOptions(inputValue: string) {
    if (inputValue.length > 2) {
      this.requestService
        .getContractNumberSearchResults(inputValue)
        .then(options => {
          this.typeAheadOptions = options;
        });
    }
  }

  onOptionSelected(selectedOption: ContractNumberSearchModel) {
    this.selectedOption = selectedOption;
    this.inputFormControl.setValue(selectedOption.contractNumber);
    this.selectedOptionChange.emit(this.selectedOption);
  }

  contractNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value == null || control.value === '') {
      return null;
    }

    if (control.value !== this.selectedOption?.contractNumber) {
      return { invalidContractNumber: true };
    }
    return null;
  }
}
